require('../../../modules/es.array.concat');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').concat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/concat.js
// module id = 353
// module chunks = 0 1